module.exports = window.$;
